module.exports = __webpack_public_path__ + "media/images/flag_usa-96555dda25a6fd39a41e395fe79e6ce3.png";